import {withStyles} from "@material-ui/core/styles";
import {Theme} from "@material-ui/core";
import React from "react";

const styles = (theme: Theme) => {
    return ({
        root: {
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap' as 'wrap',
            '& > .MuiFormControl-root': {
                margin: theme.spacing(1),
                minWidth: 200,
                flexGrow: 1
            }
        },
        dropdown: {
            marginTop: '8px',
            marginLeft: '8px'
        },
        actionContainer: {
            width: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        childrenContainer: {
            width: '100%'
        },
        deleteBtn: {
            color: theme.palette.error.main
        },
        successLabel: {
            color: theme.palette.success.main
        },
        errorsContainer: {
            width: '100%',
            color: theme.palette.error.main,
            border: 'none',
            'boxShadow': 'none',
            'border-bottom': `2px solid ${theme.palette.error.main}`,
            'borderRadius': '0 !important',

            '& .MuiExpansionPanelSummary-root': {
                padding: 0
            },
            '& .MuiExpansionPanelDetails-root': {
                padding: '8px 0'
            },
            '& .MuiExpansionPanelSummary-content.Mui-expanded': {
                margin: '20px 0'
            }
        }
    })
}

const withFormItemComponentStyle = (WrappedComponent: React.FC<any>) => withStyles(styles)(WrappedComponent);
export default withFormItemComponentStyle;
